"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XSecurityHeaders = exports.ResponseHeaders = exports.HttpStatus = exports.AsyncStateInfoStatusType = void 0;
var AsyncStateInfoStatusType;
(function (AsyncStateInfoStatusType) {
    AsyncStateInfoStatusType["AUTHORIZATION_REQUIRED"] = "AUTHORIZATION_REQUIRED";
    AsyncStateInfoStatusType["ERROR"] = "ERROR";
    AsyncStateInfoStatusType["INITIAL"] = "INITIAL";
    AsyncStateInfoStatusType["LOADING"] = "LOADING";
    AsyncStateInfoStatusType["SUCCESS"] = "SUCCESS";
})(AsyncStateInfoStatusType = exports.AsyncStateInfoStatusType || (exports.AsyncStateInfoStatusType = {}));
var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
})(HttpStatus = exports.HttpStatus || (exports.HttpStatus = {}));
var ResponseHeaders;
(function (ResponseHeaders) {
    ResponseHeaders["X_SECURITY"] = "x-security";
})(ResponseHeaders = exports.ResponseHeaders || (exports.ResponseHeaders = {}));
var XSecurityHeaders;
(function (XSecurityHeaders) {
    XSecurityHeaders["AUTHORIZATION_REQUIRED"] = "Authorization-Required";
})(XSecurityHeaders = exports.XSecurityHeaders || (exports.XSecurityHeaders = {}));
//# sourceMappingURL=useAsyncStateInfo.types.js.map